import {Tabs} from 'antd';
import {TaskTable} from './TaskTable';
import {NewTask} from "./NewTask";
import {checkPerm} from '../../auth/sessionTools'

export const TaskTab = ({session, refresh, onRefresh, onApiFail, props}) => {
    const items = [
        {
            key: 'MyTasks',
            label: 'Created by Me',
            children: <TaskTable session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} showVerified={true} taskType={"owned"}/>
        },
        {
            key: 'AssignedTasks',
            label: 'Assigned to Me',
            children: <TaskTable session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} taskType={"assigned"}/>
        },
        {
            key: 'Followed',
            label: 'Followed',
            children: <TaskTable session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} taskType={"followed"}/>
        },
        {
            key: 'NewTask',
            label: 'New Task',
            children: <NewTask refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        }
    ];

    if (checkPerm(session, "allTask")) {
        items.push({
            key: 'AllTasks',
            label: 'All Tasks',
            children: <TaskTable session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} taskType={"all"}
                                 showVerified={true}/>
        })
    }

    const onTabChange = () => {
    }

    const onClick = () => {
    }

    return <Tabs defaultActiveKey={'AssignedTasks'} tabPosition={'left'} items={items} onChange={onTabChange} onTabClick={onClick}/>
}